// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-page {
    padding: 24px;
    font-family: var(--font-sans, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif);
}

/* Title row — matches the plain title/DC-dropdown header used on Routing, Dashboard, DC File Upload */
.settings-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 2px;
    margin-bottom: 8px;
}

.settings-title {
    font-family: var(--font-sans, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif);
    font-size: 25px;
    font-weight: bold;
    color: #1d2939;
    margin: 0;
    padding: 10px;
}

.settings-title-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Card container */
.users-card {
    background: #ffffff;
    border: 1px solid #eceef2;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.06);
    overflow: hidden;
}

.users-count {
    font-size: 12px;
    font-weight: 600;
    color: #1976d2;
    background: #e3f2fd;
    border: 1px solid #bbdefb;
    padding: 5px 13px;
    border-radius: 20px;
    white-space: nowrap;
}

/* Toolbar: search + add */
.users-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    border-bottom: 1px solid #f0f2f5;
    background: #fcfcfd;
}

.users-search {
    position: relative;
    flex: 1 1;
    max-width: 420px;
    display: flex;
    align-items: center;
}

.users-search-icon {
    position: absolute;
    left: 12px;
    color: #98a2b3;
    pointer-events: none;
}

.users-search input {
    width: 100%;
    padding: 10px 36px 10px 38px;
    font-size: 13.5px;
    color: #1d2939;
    border: 1px solid #d0d5dd;
    border-radius: 9px;
    outline: none;
    background: #ffffff;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    font-family: inherit;
}

.users-search input::placeholder {
    color: #98a2b3;
}

.users-search input:focus {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.14);
}

.users-search-clear {
    position: absolute;
    right: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: none;
    border-radius: 50%;
    background: #eef1f5;
    color: #667085;
    cursor: pointer;
    transition: background 0.15s ease;
}

.users-search-clear:hover {
    background: #e2e6ec;
}

.users-add-btn {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    font-size: 13.5px;
    font-weight: 600;
    color: #ffffff;
    border: none;
    border-radius: 9px;
    cursor: pointer;
    background: linear-gradient(120deg, #1976d2 0%, #1565c0 100%);
    box-shadow: 0 2px 6px rgba(25, 118, 210, 0.25);
    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
    font-family: inherit;
}

.users-add-btn:hover {
    filter: brightness(1.05);
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.32);
    transform: translateY(-1px);
}

.users-add-btn:active {
    transform: translateY(0);
}

/* Table */
.users-table-scroll {
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 380px);
}

.users-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13.5px;
    min-width: 560px;
}

.users-table th {
    color: #475467;
    font-weight: 600;
    text-align: left;
    padding: 11px 16px;
    background: #f8fafc;
    font-size: 11.5px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-bottom: 1px solid #e9ecf1;
    position: sticky;
    top: 0;
    z-index: 1;
}

.users-table td {
    padding: 13px 16px;
    text-align: left;
    color: #344054;
    vertical-align: middle;
    border-bottom: 1px solid #f2f4f7;
}

.users-table tbody tr {
    transition: background-color 0.15s ease;
}

.users-table tbody tr:hover {
    background: #f9fbff;
}

.users-table tbody tr:last-child td {
    border-bottom: none;
}

/* flex moved to inner wrapper so td stays table-cell for correct row alignment */
.users-table td.user-cell {
    font-weight: 600;
    color: #1d2939;
}

.user-cell-inner {
    display: flex;
    align-items: center;
}

.users-table td.mono {
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
    font-size: 12.5px;
    color: #475467;
}

/* Role badge */
.role-badge {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 11px;
    border-radius: 20px;
    letter-spacing: 0.01em;
}

.role-admin {
    background: #eef0fb;
    color: #3c3489;
    box-shadow: inset 0 0 0 1px rgba(60, 52, 137, 0.14);
}

.role-user {
    background: #f2f4f7;
    color: #475467;
    box-shadow: inset 0 0 0 1px rgba(71, 84, 103, 0.12);
}

/* Status badge */
.users-table .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 11px;
    border-radius: 20px;
}

.users-table .status-badge .status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
}

.users-table .status-active {
    background: #dcfce7;
    color: #16a34a;
}

.users-table .status-active .status-dot {
    background: #16a34a;
}

.users-table .status-inactive {
    background: #f2f4f7;
    color: #667085;
}

.users-table .status-inactive .status-dot {
    background: #98a2b3;
}

/* Action column */
.users-table th.action-col {
    width: 90px;
    text-align: center;
}

.users-table td.action-col {
    text-align: center;
}

.row-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.row-actions {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.row-btn-edit {
    color: #1976d2;
    background: #e3f2fd;
    border-color: #bbdefb;
}

.row-btn-edit:hover {
    background: #bbdefb;
}

.row-btn-delete {
    color: #b42318;
    background: #fef3f2;
    border-color: #fecdca;
}

.row-btn-delete:hover {
    background: #fee4e2;
}

.users-empty {
    text-align: center !important;
    color: #98a2b3;
    padding: 32px 16px !important;
    font-style: italic;
}

/* Avatars */
.users-table .avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    margin-right: 12px;
    flex-shrink: 0;
    box-shadow: 0 0 0 2px #ffffff, 0 1px 2px rgba(16, 24, 40, 0.12);
}

.users-table .av-j { background: #b5d4f4; color: #0c447c; }
.users-table .av-s { background: #cecbf6; color: #3c3489; }
.users-table .av-a { background: #9fe1cb; color: #085041; }
.users-table .av-d { background: #f5c4b3; color: #712b13; }

/* Pagination bar */
.users-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    border-top: 1px solid #f0f2f5;
    background: #fcfcfd;
    gap: 12px;
    flex-wrap: wrap;
}

.users-page-size {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #475467;
}

.page-size-btn {
    min-width: 36px;
    height: 30px;
    padding: 0 10px;
    font-size: 13px;
    font-family: inherit;
    font-weight: 500;
    border: 1px solid #d0d5dd;
    border-radius: 7px;
    background: #ffffff;
    color: #344054;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.page-size-btn:hover {
    background: #f2f4f7;
    border-color: #b0b8c7;
}

.page-size-btn.active {
    background: #1976d2;
    border-color: #1976d2;
    color: #ffffff;
    font-weight: 600;
}

.users-page-nav {
    display: flex;
    align-items: center;
    gap: 8px;
}

.page-info {
    font-size: 13px;
    color: #475467;
    min-width: 110px;
    text-align: right;
}

.page-nav-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid #d0d5dd;
    border-radius: 7px;
    background: #ffffff;
    color: #344054;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.page-nav-btn:hover:not(:disabled) {
    background: #f2f4f7;
    border-color: #b0b8c7;
}

.page-nav-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.page-num-btn.active {
    background: #1976d2;
    border-color: #1976d2;
    color: #ffffff;
    font-weight: 600;
}

.page-ellipsis {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 13px;
    color: #98a2b3;
    -webkit-user-select: none;
            user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/Users.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wFAAwF;AAC5F;;AAEA,sGAAsG;AACtG;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,wFAAwF;IACxF,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,+EAA+E;IAC/E,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,0DAA0D;IAC1D,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6DAA6D;IAC7D,8CAA8C;IAC9C,0EAA0E;IAC1E,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iFAAiF;AACjF;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,4EAA4E;IAC5E,iBAAiB;IACjB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mDAAmD;AACvD;;AAEA,iBAAiB;AACjB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,YAAY;AACZ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,+DAA+D;AACnE;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,0DAA0D;AAC9D;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;AACrB","sourcesContent":[".users-page {\n    padding: 24px;\n    font-family: var(--font-sans, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif);\n}\n\n/* Title row — matches the plain title/DC-dropdown header used on Routing, Dashboard, DC File Upload */\n.settings-title-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 2px;\n    margin-bottom: 8px;\n}\n\n.settings-title {\n    font-family: var(--font-sans, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif);\n    font-size: 25px;\n    font-weight: bold;\n    color: #1d2939;\n    margin: 0;\n    padding: 10px;\n}\n\n.settings-title-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n/* Card container */\n.users-card {\n    background: #ffffff;\n    border: 1px solid #eceef2;\n    border-radius: 14px;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.06);\n    overflow: hidden;\n}\n\n.users-count {\n    font-size: 12px;\n    font-weight: 600;\n    color: #1976d2;\n    background: #e3f2fd;\n    border: 1px solid #bbdefb;\n    padding: 5px 13px;\n    border-radius: 20px;\n    white-space: nowrap;\n}\n\n/* Toolbar: search + add */\n.users-toolbar {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 24px;\n    border-bottom: 1px solid #f0f2f5;\n    background: #fcfcfd;\n}\n\n.users-search {\n    position: relative;\n    flex: 1;\n    max-width: 420px;\n    display: flex;\n    align-items: center;\n}\n\n.users-search-icon {\n    position: absolute;\n    left: 12px;\n    color: #98a2b3;\n    pointer-events: none;\n}\n\n.users-search input {\n    width: 100%;\n    padding: 10px 36px 10px 38px;\n    font-size: 13.5px;\n    color: #1d2939;\n    border: 1px solid #d0d5dd;\n    border-radius: 9px;\n    outline: none;\n    background: #ffffff;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n    font-family: inherit;\n}\n\n.users-search input::placeholder {\n    color: #98a2b3;\n}\n\n.users-search input:focus {\n    border-color: #1976d2;\n    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.14);\n}\n\n.users-search-clear {\n    position: absolute;\n    right: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border: none;\n    border-radius: 50%;\n    background: #eef1f5;\n    color: #667085;\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.users-search-clear:hover {\n    background: #e2e6ec;\n}\n\n.users-add-btn {\n    margin-left: auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 18px;\n    font-size: 13.5px;\n    font-weight: 600;\n    color: #ffffff;\n    border: none;\n    border-radius: 9px;\n    cursor: pointer;\n    background: linear-gradient(120deg, #1976d2 0%, #1565c0 100%);\n    box-shadow: 0 2px 6px rgba(25, 118, 210, 0.25);\n    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n    font-family: inherit;\n}\n\n.users-add-btn:hover {\n    filter: brightness(1.05);\n    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.32);\n    transform: translateY(-1px);\n}\n\n.users-add-btn:active {\n    transform: translateY(0);\n}\n\n/* Table */\n.users-table-scroll {\n    overflow-x: auto;\n    overflow-y: auto;\n    max-height: calc(100vh - 380px);\n}\n\n.users-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    font-size: 13.5px;\n    min-width: 560px;\n}\n\n.users-table th {\n    color: #475467;\n    font-weight: 600;\n    text-align: left;\n    padding: 11px 16px;\n    background: #f8fafc;\n    font-size: 11.5px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    border-bottom: 1px solid #e9ecf1;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.users-table td {\n    padding: 13px 16px;\n    text-align: left;\n    color: #344054;\n    vertical-align: middle;\n    border-bottom: 1px solid #f2f4f7;\n}\n\n.users-table tbody tr {\n    transition: background-color 0.15s ease;\n}\n\n.users-table tbody tr:hover {\n    background: #f9fbff;\n}\n\n.users-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n/* flex moved to inner wrapper so td stays table-cell for correct row alignment */\n.users-table td.user-cell {\n    font-weight: 600;\n    color: #1d2939;\n}\n\n.user-cell-inner {\n    display: flex;\n    align-items: center;\n}\n\n.users-table td.mono {\n    font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n    font-size: 12.5px;\n    color: #475467;\n}\n\n/* Role badge */\n.role-badge {\n    display: inline-flex;\n    align-items: center;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 3px 11px;\n    border-radius: 20px;\n    letter-spacing: 0.01em;\n}\n\n.role-admin {\n    background: #eef0fb;\n    color: #3c3489;\n    box-shadow: inset 0 0 0 1px rgba(60, 52, 137, 0.14);\n}\n\n.role-user {\n    background: #f2f4f7;\n    color: #475467;\n    box-shadow: inset 0 0 0 1px rgba(71, 84, 103, 0.12);\n}\n\n/* Status badge */\n.users-table .status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 3px 11px;\n    border-radius: 20px;\n}\n\n.users-table .status-badge .status-dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.users-table .status-active {\n    background: #dcfce7;\n    color: #16a34a;\n}\n\n.users-table .status-active .status-dot {\n    background: #16a34a;\n}\n\n.users-table .status-inactive {\n    background: #f2f4f7;\n    color: #667085;\n}\n\n.users-table .status-inactive .status-dot {\n    background: #98a2b3;\n}\n\n/* Action column */\n.users-table th.action-col {\n    width: 90px;\n    text-align: center;\n}\n\n.users-table td.action-col {\n    text-align: center;\n}\n\n.row-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.row-actions {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.row-btn-edit {\n    color: #1976d2;\n    background: #e3f2fd;\n    border-color: #bbdefb;\n}\n\n.row-btn-edit:hover {\n    background: #bbdefb;\n}\n\n.row-btn-delete {\n    color: #b42318;\n    background: #fef3f2;\n    border-color: #fecdca;\n}\n\n.row-btn-delete:hover {\n    background: #fee4e2;\n}\n\n.users-empty {\n    text-align: center !important;\n    color: #98a2b3;\n    padding: 32px 16px !important;\n    font-style: italic;\n}\n\n/* Avatars */\n.users-table .avatar {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 600;\n    margin-right: 12px;\n    flex-shrink: 0;\n    box-shadow: 0 0 0 2px #ffffff, 0 1px 2px rgba(16, 24, 40, 0.12);\n}\n\n.users-table .av-j { background: #b5d4f4; color: #0c447c; }\n.users-table .av-s { background: #cecbf6; color: #3c3489; }\n.users-table .av-a { background: #9fe1cb; color: #085041; }\n.users-table .av-d { background: #f5c4b3; color: #712b13; }\n\n/* Pagination bar */\n.users-pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 20px;\n    border-top: 1px solid #f0f2f5;\n    background: #fcfcfd;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.users-page-size {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: #475467;\n}\n\n.page-size-btn {\n    min-width: 36px;\n    height: 30px;\n    padding: 0 10px;\n    font-size: 13px;\n    font-family: inherit;\n    font-weight: 500;\n    border: 1px solid #d0d5dd;\n    border-radius: 7px;\n    background: #ffffff;\n    color: #344054;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.page-size-btn:hover {\n    background: #f2f4f7;\n    border-color: #b0b8c7;\n}\n\n.page-size-btn.active {\n    background: #1976d2;\n    border-color: #1976d2;\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.users-page-nav {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.page-info {\n    font-size: 13px;\n    color: #475467;\n    min-width: 110px;\n    text-align: right;\n}\n\n.page-nav-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border: 1px solid #d0d5dd;\n    border-radius: 7px;\n    background: #ffffff;\n    color: #344054;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.page-nav-btn:hover:not(:disabled) {\n    background: #f2f4f7;\n    border-color: #b0b8c7;\n}\n\n.page-nav-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n.page-num-btn.active {\n    background: #1976d2;\n    border-color: #1976d2;\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.page-ellipsis {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    font-size: 13px;\n    color: #98a2b3;\n    user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
